import { Component } from 'react';
import { bugsnagError } from 'services/bugsnag';

export default class ConvertProviderHOC extends Component {
  componentDidMount () {
    const { authData, windowLoaded } = this.props;

    // wait until window is loaded to load Convert
    if (windowLoaded && authData) {
      this.loadConvertJS(authData);
    }

    if (window.convert) {
      window._conv_q = window._conv_q || [];
      window._conv_q.push(['run', 'true']);
    }
  }

  componentDidUpdate (prevProps) {
    const { authData, windowLoaded, location } = this.props;

    // if we didn't load in componentDidMount
    // load when window is loaded and when the path changes
    const windowJustLoaded = windowLoaded && !prevProps.windowLoaded;
    const newPath = windowLoaded && location.pathname !== prevProps.location.pathname;
    if ((windowJustLoaded || newPath) && authData) {
      this.loadConvertJS(authData);
    }

    if (window.convert) {
      window._conv_q = window._conv_q || [];
      window._conv_q.push(['run', 'true']);
      window._conv_q.push(['recheck_goals']);
    }
  }

  loadConvertJS = (authData) => {
    try {
      let script = document.createElement('script');
      script.onload = () => {
        window._conv_q = window._conv_q || [];
        window._conv_q.push(['run', 'true']);

        // Leaving this in for clarity
        console.log('Convert Loaded');
      };
      script.type = 'text/javascript';
      script.async = true;
      script.src = '//cdn-3.convertexperiments.com/js/1003433-1003328.js';

      // This kicks off an async download of the script
      document.head.appendChild(script);
    } catch (exception) {
      bugsnagError(new Error(`Exception encountered when trying to load Convert: ${exception}`));
    }
  }

  render () {
    return this.props.children;
  }
}

/**
 * This returns the experiments that were triggered when we read the object
 */
export const getActiveExperiments = () => {
  if (!window.convert) {
    convertError(window.convert);
  }

  return window.convert.currentData.experiments;
};

export const isExperimentActive = (experimentId) => {
  if (experimentId) {
    const experiments = getActiveExperiments();
    return experiments && experiments.includes(experimentId);
  }
};

/**
 * Returns the variationId of the variation that was selected for this experiment
 * @param {Number} experimentId
 */
export const getExperimentVariationId = (experimentId) => {
  const wc = window.convert;
  if (!wc) {
    convertError(window.convert);
  }

  const variations = wc.data.experiments[experimentId].vars;
  const variationId = variations && Object.keys(variations)[0];
  return variationId;
};

const convertError = (wc) => {
  bugsnagError(new Error(`Convert loaded but window.convert is ${wc}`));
  return null;
};
